import React from 'react';
import { LoanDocument } from '../types';
import { DocumentItem } from './DocumentItem';
interface DocumentListProps {
  documents: LoanDocument[];
  onUploadClick: (doc: LoanDocument) => void;
}
export function DocumentList({
  documents,
  onUploadClick
}: DocumentListProps) {
  const pendingCount = documents.filter(d => d.status === 'pending').length;
  const completedCount = documents.length - pendingCount;
  const progress = Math.round(completedCount / documents.length * 100);
  return <div className="bg-white rounded-2xl shadow-sm border border-slate-200 overflow-hidden" data-id="element-34">
      <div className="p-6 border-b border-slate-100" data-id="element-35">
        <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4 mb-6" data-id="element-36">
          <div data-id="element-37">
            <h2 className="text-xl font-semibold text-slate-900" data-id="element-38">
              Required Documents
            </h2>
            <p className="text-sm text-slate-500 mt-1" data-id="element-39">
              Please provide the following documents to process your
              application.
            </p>
          </div>
          <div className="text-right" data-id="element-40">
            <div className="text-2xl font-bold text-slate-900" data-id="element-41">{progress}%</div>
            <div className="text-xs font-medium text-slate-500 uppercase tracking-wider" data-id="element-42">
              Completed
            </div>
          </div>
        </div>

        {/* Progress Bar */}
        <div className="w-full bg-gray-100 rounded-full h-2.5 mb-2 overflow-hidden" data-id="element-43">
          <div className="bg-green-600 h-2.5 rounded-full transition-all duration-1000 ease-out" style={{
          width: `${progress}%`
        }} data-id="element-44"></div>
        </div>
        <p className="text-xs text-slate-500" data-id="element-45">
          {completedCount} of {documents.length} documents provided
        </p>
      </div>

      <div className="p-6" data-id="element-46">
        <div className="space-y-3" data-id="element-47">
          {documents.map(doc => <DocumentItem key={doc.id} document={doc} onUploadClick={onUploadClick} data-id="element-48" />)}
        </div>
      </div>
    </div>;
}